import env from '@travel/env';

const assetsPath = env('UNIVERSAL_ASSETS_PATH');

__webpack_public_path__ =
  process.env.NODE_ENV === 'production' && assetsPath ? `${assetsPath}/` : '/';
